import { createContext, useState } from "react";

export const SignUpModalContext = createContext({
  openSignUpModal: false,
  setOpenSignUpModal: () => false,
});

export const SignUpModalProvider = ({ children }) => {
  const [openSignUpModal, setOpenSignUpModal] = useState(false);
  const value = { openSignUpModal, setOpenSignUpModal };
  return (
    <SignUpModalContext.Provider value={value}>
      {children}
    </SignUpModalContext.Provider>
  );
};
